export const teams = {
  teamsList: {
    name: 'Team Name',
    members: 'Members',
  }
};
